import { StyleSheet } from '@/core/StyleSheet';

export default StyleSheet.create({
	content: {
		alignItems: 'center',
		flexDirection: 'row',
		paddingVertical: 10,
	},

	checkbox: {
		height: 20,
		marginRight: 10,
		width: 20,
	},

	label: {
		height: 20,
	},
});
